/**
 * Vendor program block for apps.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment'; 
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from '@mui/material';

import AppLogo from '../ui/AppLogo';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';

const abEnvironment = new AbEnvironment();
const VendorPartnerProgramBlockAppsQuery = graphql`
query VendorPartnerProgramBlockAppsQuery($resellerId: UUID!, $vendorId: UUID!) {
  getresellerappsoemtovendor(resellerid: $resellerId, vendorid: $vendorId) {
    totalCount
    nodes {
      appId
      appName
      appSku
      appLogo
      oemAppId
      oemAppName
      oemAppSku
      plans {
        resellerPId
        programName
        description
      }
      numSubs
    }
  }
}
 `;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    tblHead: {
      backgroundColor: '#f1f1f1'
    }
  });
  
class VendorPartnerProgramBlockApps extends Component {
  state = {
    apps: null
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedVendor()) {
      return (
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow>
                <TableCell>App</TableCell>
                <TableCell>Plans</TableCell>
                <TableCell align="right">Active subscriptions</TableCell>
                {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      );
    } else if (isAuthenticatedReseller()) {

      let vpp = this.props.vpp;
      let vr = this.props.vppRelationship;

      let vendorId = vpp.vendorId;
      let partnerId = vr.partnerId;

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={VendorPartnerProgramBlockAppsQuery}
          variables={{resellerId: partnerId, vendorId: vendorId}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              let lines = props.getresellerappsoemtovendor.nodes;
              return (
                <TableContainer>
                  <Table>
                    <TableHead className={classes.tblHead}>
                      <TableRow>
                        <TableCell>App</TableCell>
                        <TableCell>Plans</TableCell>
                        <TableCell align="right">Active subscriptions</TableCell>
                        {/*<TableCell align="center">{deleteHeader}</TableCell>*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {lines.map(line => {
                        let theUrl = "app?appId=" + line.appId;
                        let thePlansString = "";

                        if (line.plans != null && line.plans.length > 0) {
                          for (let i=0,j=0; i<line.plans.length; i++) {
                            let aplan = line.plans[i];

                            if (aplan.programName != null) {
                              if (j>0) {
                                thePlansString = thePlansString + ", ";
                              }
                              j++;

                              thePlansString = thePlansString + aplan.programName + " (" + aplan.description + ")";
                            }                            
                          }
                        }

                        return(
                          <TableRow key={line.appId}>
                            <TableCell>
                              <Grid container alignItems="center">
                                <Grid item>
                                  <AppLogo logoPath={line.appLogo} appName={line.appName} imageHeight='24px' theStyle={{marginRight: '8px'}}/>
                                </Grid>
                                <Grid item >
                                  <Link component="button" 
                                        variant="body2"
                                        onClick={this.goTo.bind(this, theUrl)}>
                                    {line.appName}
                                  </Link>
                                  {line.appSku != null && line.appSku !== '' && line.appSku !== line.appName &&
                                    <Typography variant="body2" >{line.appSku}</Typography>
                                  }
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">{thePlansString}</Typography>
                            </TableCell>
                            <TableCell align="right">
                              {line.numSubs}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
             );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

VendorPartnerProgramBlockApps.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(VendorPartnerProgramBlockApps);
